import { toast } from 'react-toastify';

import { useConfiguratorDispatch, useRootSelector } from '../../store';

import {
  clearInvalidConfigIds,
  flagInvalidConfigIds,
  selectAllConfigSnapshots
} from './store/multiConfigSlice';
import { getConfigNameValue } from './utils';

// Add to Cart validation for multi-config sessions: every configuration
// needs a name, not just enough of them (selectIsBelowConfigMinimum/
// belowConfigMinimum cover the count via the button's own disabled state).
// Returns a function that checks this at click time, flags any offending
// configs (read by ConfigSessionSwitcher to briefly open the dropdown and
// highlight them) and toasts which ones are missing a name - callers should
// treat a `false` return as "do not add to cart". No-ops (always returns
// true) outside of a multi-config session, since selectAllConfigSnapshots
// is empty until one starts.
export function useValidateMultiConfigNames() {
  const dispatch = useConfiguratorDispatch();
  const configSnapshots = useRootSelector(selectAllConfigSnapshots);

  return () => {
    const invalid = configSnapshots
      .map((snapshot, index) => ({ ...snapshot, index }))
      .filter(snapshot => !getConfigNameValue(snapshot.properties)?.trim());

    if (invalid.length === 0) {
      dispatch(clearInvalidConfigIds());
      return true;
    }

    const labels = invalid.map(({ index }) => `Name ${index + 1}`);
    const message = `Please add a name for: ${labels.join(
      ', '
    )} before adding to cart`;
    // position/toastId match CustomerConfigurator's displayErrors, so all
    // validation toasts in the configurator land in the same place.
    toast.error(message, { toastId: message, position: 'bottom-right' });
    dispatch(flagInvalidConfigIds(invalid.map(({ id }) => id)));
    return false;
  };
}
